// the backdrop, when sidebar is opened
// logo
// lang
import React from 'react';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../../UI/Backdrop/Backdrop';
import classes from './SideDrawer.module.css';
import NavigationItems from '../NavigationItems/NavigationItems';

const sideDrawer = (props) => {
    let attachClasses = [classes.SideDrawer, classes.Close];

    if (props.toOpen) {
        attachClasses = [classes.Open, classes.OpenTransform];
    }

    return (
        <Aux>
            <Backdrop showBackdrop={props.toOpen} clicked={props.toClose} />
            <div className={attachClasses.join(' ')} onClick={props.toClose}>
                <nav className={classes.NavSideDrawer}>
                    <NavigationItems sideDrawer />
                </nav>
            </div>
        </Aux>
    )
};

export default sideDrawer;